import { forwardRef } from 'react';
import TextAreaInternal from './text-area-internal';
var TextArea = forwardRef(TextAreaInternal);
export default TextArea;
